import { Container, Title, Text, Button, Group, Badge, Box, ThemeIcon, Stack } from "@mantine/core";
import { IconArrowRight, IconShieldCheck, IconCircleCheck, IconShield, IconFileCheck } from "@tabler/icons-react";
import { Link } from "react-router-dom";

export default function HeroSection() {
  return (
    <Box
      style={{
        position: "relative",
        overflow: "hidden",
        background: "linear-gradient(to bottom, rgba(235, 248, 255, 0.8) 0%, rgba(255, 255, 255, 0) 90%)",
      }}
      pt={120}
      pb={120}
    >
      <Container size="lg" style={{ position: "relative", zIndex: 1 }}>
        <Stack align="center" gap="xl">
          {/* Badge */}
          <Badge
            variant="light"
            color="primary"
            size="lg"
            radius="max"
            styles={{
              root: {
                textTransform: "none",
                padding: "0.5rem 1rem",
                height: "auto",
                border: "1px solid var(--mantine-color-primary-2)",
              },
              label: { fontWeight: 500, fontSize: "0.9rem" },
            }}
            leftSection={
              <ThemeIcon variant="transparent" size="sm">
                <IconShieldCheck size={14} />
              </ThemeIcon>
            }
          >
            Compliance-Backed Business Network
          </Badge>

          {/* Headline */}
          <Title order={1} ta="center" size={52} fw={900} lh={1.1}>
            Trusted, Verified Global <br /> Business Network
          </Title>

          {/* Subheadline */}
          <Text ta="center" c="slate.6" size="xl" maw={700} lh={1.6} style={{ fontSize: "1.125rem" }}>
            Compliance-backed discovery and secure business collaboration.{" "}
            <Text ta="center" c="slate.6" size="xl" maw={700} lh={1.6} style={{ fontSize: "1.125rem" }}>
              Connect with verified manufacturers and partners worldwide.
            </Text>
          </Text>

          {/* Buttons */}
          <Group mt="lg" gap="md" justify="center">
            <Button
              component={Link}
              to="/discover"
              size="xl"
              radius="lg"
              color="primary"
              rightSection={<IconArrowRight size={18} />}
              styles={{ root: { paddingLeft: 30, paddingRight: 30, minWidth: 240 } }}
            >
              Explore Companies
            </Button>
            <Button
              component={Link}
              to="/signup"
              size="xl"
              radius="lg"
              variant="outline"
              color="primary"
              styles={{ root: { paddingLeft: 30, paddingRight: 30, borderWidth: 1.5, minWidth: 240 } }}
            >
              Register Your Company
            </Button>
          </Group>

          {/* Trust Badges */}
          <Group mt={50} gap={40} wrap="wrap" justify="center">
            <Group gap="xs">
              <ThemeIcon color="teal" variant="light" radius="xl" size="md">
                <IconCircleCheck size={18} />
              </ThemeIcon>
              <Text size="sm" fw={400} c="slate.6">
                Verified Companies Only
              </Text>
            </Group>
            <Group gap="xs">
              <ThemeIcon color="teal" variant="light" radius="xl" size="md">
                <IconShield size={18} />
              </ThemeIcon>
              <Text size="sm" fw={400} c="slate.6">
                Secure Workspace
              </Text>
            </Group>
            <Group gap="xs">
              <ThemeIcon color="teal" variant="light" radius="xl" size="md">
                <IconFileCheck size={18} />
              </ThemeIcon>
              <Text size="sm" fw={400} c="slate.6">
                NDA Protection
              </Text>
            </Group>
          </Group>
        </Stack>
      </Container>
    </Box>
  );
}
